import { useEffect, useState } from 'react';
import { throttle, isEqual } from 'lodash';
import useWindowEvent from 'hooks/useWindowEvent';
import { BREAKPOINT_COOKIE_KEY, DEFAULT_SSR_BREAKPOINTS } from 'constants/breakpoint';
import { getBreakpointsFromDevice, getBreakpointsFromWidth } from 'libs/utils/breakpoints';
import { saveCookie } from 'libs/utils/cookies';
import { relativeDate } from 'libs/utils/date';
import { serverSide } from 'libs/utils/environment';
import { getBrowserWidth } from 'libs/utils/window';
import { Provider } from './BreakpointContext';
import { jsx as _jsx } from "react/jsx-runtime";
const RESIZE_DELAY = 50;

function setViewportCookie() {
  if (serverSide) return;
  saveCookie(BREAKPOINT_COOKIE_KEY, getBrowserWidth().toString(), relativeDate({
    days: 1
  }));
}

function getClientSideBreakpoints() {
  return getBreakpointsFromWidth(getBrowserWidth());
}

function getServerSideBreakpoints(viewportSize, device) {
  if (viewportSize) return getBreakpointsFromWidth(viewportSize);
  if (device) return getBreakpointsFromDevice(device);
  return DEFAULT_SSR_BREAKPOINTS;
}

function getBreakpoints(viewportSize, device) {
  if (serverSide) return getServerSideBreakpoints(viewportSize, device);
  return getClientSideBreakpoints();
}

const BreakpointProvider = _ref => {
  let {
    children,
    viewportSize,
    device
  } = _ref;
  const {
    0: breakpoints,
    1: setBreakpoints
  } = useState(() => getBreakpoints(viewportSize, device));
  useEffect(() => {
    setViewportCookie();
  }, []);
  useWindowEvent('resize', throttle(() => {
    const newBreakpoints = getClientSideBreakpoints();
    setViewportCookie();
    setBreakpoints(prevBreakpoints => isEqual(newBreakpoints, prevBreakpoints) ? prevBreakpoints : newBreakpoints);
  }, RESIZE_DELAY));
  return /*#__PURE__*/_jsx(Provider, {
    value: {
      breakpoints
    },
    children: children
  });
};

export default BreakpointProvider;